import React from 'react';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import Dialog from 'Components/UI/Dialog';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDDialogTitle,
} from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { BodyTextMedium, BodyTextSmall, PasswordInputLarge } from 'Packages/FacetDesign/Components';
import { useAuthenticationFactorListContext } from '../AuthenticationFactorListContext';
import { FormLayout } from './FormLayout';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride('title', { _component: () => FDDialogTitle }, overrideReadOnly)
  .nameOverride('primaryText', { _component: () => BodyTextMedium }, overrideReadOnly)
  .nameOverride('description', { _component: () => BodyTextMedium }, overrideReadOnly)
  .nameOverride(['currentPassword', 'newPassword'], { _component: () => PasswordInputLarge }, overrideReadOnly)
  .nameOverride('secret', { _component: () => BodyTextSmall }, overrideReadOnly);

export const AuthFactorModalContent = () => {
  const { handleInterceptResponse } = useIdentityChallengeContext();
  const { clearModalLink, refreshListCollection } = useAuthenticationFactorListContext();
  const { collection, setCollection } = useCollectionStateContext();
  const modalResource = collection.resources().head();

  return (
    <Dialog // This component is critical because it sets data-modal-type="dialog" which DICRS uses to hide the dialog
      open={!!modalResource}
      onClose={clearModalLink}
    >
      {modalResource ? <MetaResourceRenderer
        resource={modalResource}
        layout={FormLayout}
        metaOverrideSet={metaOverrides}
        onSubmit={(possiblyDicrsResponse) => {
          return handleInterceptResponse(possiblyDicrsResponse, (originalRequestResponse) => {
            setCollection(originalRequestResponse);
            refreshListCollection();
            return originalRequestResponse;
          });
        }}
      /> : null}
    </Dialog>
  );
};
